<div class="staff-list-container">
  @for (relationType of relationTypeList; track relationType) {
    <div class="relation-grid">
      <div class="section-header">{{relationType}}</div>
      <div class="ui doubling six column grid">
        @for (item of itemsWithRelationMap[relationType]; track item) {
          <div class="column">
            <div class="ui segment staff-card">
              <div class="image">
            <ui-responsive-image [src]="item.coverImage.url" [size]="{
              width: '100%',
              ratio: item.imageRatio,
              originalWidth: item.coverImage.width,
              originalHeight: item.coverImage.height
            }" [background]="item.coverImage.dormantColor"></ui-responsive-image>
              </div>
              <div class="staff-name">{{item.nameCn || item.name}}</div>
              <div class="staff-alt-name">{{item.nameCn ? item.name : ''}}</div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
